import React, { useEffect, useState } from 'react';
import { BaseViewportPlugin, useFramework } from '@/framework';
import { PluginType, type IExportPlugin } from '@/version-types';
import { backgroundLayerPlugin } from '../../../..';
import CropBackgroundWrap from './components/crop-background-wrap';
import { CropBackground } from './crop-background';
import { CROP_BACKGROUND_EVENTS } from './event-name';

const CropBackgroundPlugin: React.FC = React.memo(() => {
    const framework = useFramework();

    const [open, setOpen] = useState(false);
    useEffect(() => {
        const handlers = [
            framework.service.events.on(CROP_BACKGROUND_EVENTS.CROP_OPEN, () => setOpen(true)),
            framework.service.events.on(CROP_BACKGROUND_EVENTS.CROP_CLOSE, () => setOpen(false)),
        ];
        return () => {
            handlers.forEach((handler) => {
                framework.service.events.off(handler);
            });
        };
    }, []);

    if (!open) return null;

    return (
        <BaseViewportPlugin name="crop-background">
            <CropBackgroundWrap />
        </BaseViewportPlugin>
    );
});

const exportPlugin: IExportPlugin = {
    type: PluginType.VIEWPORT,
    sort: 3,
    name: 'crop-background',
    createInstance({ identity }) {
        return [{ key: 'CropBackground', value: new CropBackground(identity) }];
    },
    render() {
        return <CropBackgroundPlugin />;
    },
    dependencies() {
        return [{ plugin: backgroundLayerPlugin }];
    },
};

export default exportPlugin;
